import { ungzip } from 'pako'

export const tgsToLottie = async (tgsData: ArrayBuffer): Promise<any> => {
  try {

    const decompressed = ungzip(new Uint8Array(tgsData))
    const jsonString = new TextDecoder().decode(decompressed)
    const animationData = JSON.parse(jsonString)

    return animationData
  } catch (error) {
    console.error('Error converting TGS to Lottie:', error)
    throw error
  }
}

export const loadTgsAnimation = async (tgsUrl: string): Promise<any> => {
  try {
    const response = await fetch(tgsUrl)
    const tgsData = await response.arrayBuffer()

    return await tgsToLottie(tgsData)
  } catch (error) {
    console.error('Error loading TGS animation:', error)
    throw error
  }
} 